import { OnboardingBaseTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useOnboardingCallEligibility } from '../hooks/use-onboarding-call-eligibility';
import type { TaskAction, TaskActionArgs } from '../types';
import { useAssignUserRolesAction } from './use-assign-user-roles-action';
import { useExploreCallHistoryAction } from './use-explore-call-history-action';
import { useReviewConversationAnalysisAction } from './use-review-conversation-analysis-action';
import { useViewCallInsightsAction } from './use-view-call-insights-action';
import { useViewPatientContextAction } from './use-view-patient-context-action';

export function useTaskActions(args: TaskActionArgs): Partial<Record<OnboardingBaseTask, TaskAction>> {
  useOnboardingCallEligibility();

  const exploreCallHistory = useExploreCallHistoryAction(args);
  const viewCallInsights = useViewCallInsightsAction(args);
  const reviewConversationAnalysis = useReviewConversationAnalysisAction(args);
  const viewPatientContext = useViewPatientContextAction(args);
  const assignUserRoles = useAssignUserRolesAction(args);

  return {
    [OnboardingBaseTask.BASE_TASK_EXPLORE_CALL_HISTORY]: exploreCallHistory,
    [OnboardingBaseTask.BASE_TASK_VIEW_CALL_INSIGHTS]: viewCallInsights,
    [OnboardingBaseTask.BASE_TASK_REVIEW_CONVERSATION_ANALYSIS]: reviewConversationAnalysis,
    [OnboardingBaseTask.BASE_TASK_VIEW_PATIENT_CONTEXT]: viewPatientContext,
    [OnboardingBaseTask.BASE_TASK_ASSIGN_USER_ROLES]: assignUserRoles,
  };
}
